import React from "react";
import { PCRALogBoxPastOrPending } from "./PCRALogBoxPastOrPending";

export function PCRALogBoxPending(props) {
  return (
    <PCRALogBoxPastOrPending comments="" username="" email="" timestamp="" />
  );
}
